import React from 'react';
import { useHistory } from 'react-router-dom';

export const ContactPage: React.FC = () => {
  const history = useHistory();

  return (
    <>
      <h1>聯絡我們</h1>
      <p className="dc-lead">依問題類型提供適當窗口與說明。</p>

      <section className="dc-note" style={{ marginTop: '16px' }}>
        <h2>國立成功大學電子證書服務小組</h2>
        <p style={{ overflowWrap: 'anywhere', marginTop: '8px' }}>
          <a href="mailto:dcert-service@netdb.csie.ncku.edu.tw">
            dcert-service@netdb.csie.ncku.edu.tw
          </a>
        </p>
      </section>

      <h2 style={{ marginTop: '28px' }}>來信時可提供</h2>
      <ul className="dc-list">
        <li>需要協助的服務項目</li>
        <li>遇到問題的操作步驟與畫面訊息</li>
      </ul>

      <div className="dc-actions" style={{ marginTop: '28px' }}>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/about')}
        >
          回到中心介紹
        </button>
      </div>
    </>
  );
};

export default ContactPage;
